"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { HEADER_ICON_MAP } from "@/shared/constants/icon-map";
import useIconAction from "@/shared/hooks/useIconAction";
import useUIStore from "@/shared/stores/ui/store";
import { HeaderIconName } from "@/shared/types/type/icon";
import { Language } from "@/shared/types/type/language";
import { CustomButton } from "@/shared/ui/molecules";
interface SubHeaderProps {
  title?: string;
  leftButtons?: HeaderIconName[];
  rightButtons?: HeaderIconName[];
}
const SubHeader = t0 => {
  const $ = _c(16);
  const {
    title: t1,
    leftButtons,
    rightButtons
  } = t0;
  const title = t1 === undefined ? "" : t1;
  const {
    setLanguage
  } = useUIStore();
  const language = usePathname()?.split("/")[1] as Language;
  const {
    getAction
  } = useIconAction();
  let t2;
  let t3;
  if ($[0] !== language || $[1] !== setLanguage) {
    t2 = () => {
      setLanguage(language);
    };
    t3 = [language, setLanguage];
    $[0] = language;
    $[1] = setLanguage;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== title) {
    t4 = title && <h1 className="fs absolute left-[50%] translate-x-[-50%] top-[13px] text-center text-gray-900 font-semibold" style={{
      "--fs": 18,
      "--lh": 25
    } as React.CSSProperties}>{title}</h1>;
    $[4] = title;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== getAction || $[7] !== leftButtons) {
    t5 = leftButtons && leftButtons.length > 0 ? <>{leftButtons.map((item, index) => {
        const IconComponent = HEADER_ICON_MAP[item as HeaderIconName];
        return <CustomButton key={`btn-left-${index}`} onClick={getAction(item)}><IconComponent /></CustomButton>;
      })}</> : <> </>;
    $[6] = getAction;
    $[7] = leftButtons;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== getAction || $[10] !== rightButtons) {
    t6 = rightButtons && rightButtons.map((item_0, index_0) => {
      const IconComponent_0 = HEADER_ICON_MAP[item_0 as HeaderIconName];
      return <CustomButton key={`btn-right-${index_0}`} onClick={getAction(item_0)}><IconComponent_0 /></CustomButton>;
    });
    $[9] = getAction;
    $[10] = rightButtons;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <header className="sticky top-0 z-[101] py-[13px] pl-4 pr-[14px] flex items-center justify-between w-full min-h-[44px] bg-white">{t4}{t5}{t6}</header>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default SubHeader;